import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { Activity, Users, MessageSquare, BarChart3, Zap } from 'lucide-react';

const DashboardLayout = () => {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Dashboard', icon: Activity },
    { path: '/whatsapp', label: 'WhatsApp', icon: MessageSquare },
    { path: '/coaches', label: 'Coaches', icon: Users },
    { path: '/groups', label: 'Groups', icon: MessageSquare },
    { path: '/reports', label: 'Reports', icon: BarChart3 },
  ];

  return (
    <div className="flex min-h-screen bg-background">
      <aside className="w-64 bg-card border-r border-border sticky top-0 h-screen">
        <div className="p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary rounded-md flex items-center justify-center">
              <Zap className="w-6 h-6 text-primary-foreground" />
            </div>
            <div>
              <h1 className="text-xl font-heading font-bold text-foreground">COACH COMMAND</h1>
              <p className="text-xs text-muted-foreground">Performance Monitor</p>
            </div>
          </div>
        </div>
        
        <nav className="p-4 space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-md font-body text-sm transition-colors duration-200 ${
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
                }`}
              >
                <Icon className="w-5 h-5" strokeWidth={2} />
                <span className="font-medium">{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
      </aside>

      <main className="flex-1 overflow-auto">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
